import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareBacklogEmbedRoute: InvariantJiraRoute = {
	name: 'software-backlog-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
	exact: true,
};
